<script>
export default {
  props: {
    csvHeaders: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: '',
    },
    isCsvAudience: {
      type: Boolean,
      default: false,
    },
    availableContactInfos: {
      type: Array,
      required: true,
    },
    isOngoing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paramType: 'fixed',
      paramValue: this.value,
      fieldSelected: '',
    };
  },
  watch: {
    isCsvAudience(newVal) {
      if (newVal) {
        this.resetVariables();
      }
    },
  },
  mounted() {},
  methods: {
    onChange(newValue = null) {
      // The type of parameter for labels will always be fixed,
      // as the replacement of variabels will only be done in backend (triggering campaign)
      let param_type_checked = this.isCsvAudience ? this.paramType : 'fixed';
      // Use newValue if provided (from @input event), otherwise fall back to current values
      const currentParamValue = newValue !== null ? newValue : this.paramValue;
      let param_value_checked = this.isCsvAudience
        ? currentParamValue
        : this.fieldSelected;

      this.$emit('changeFieldValue', {
        type: param_type_checked,
        value: param_value_checked || currentParamValue,
        fieldSelected: this.fieldSelected,
      });
    },
    resetVariables() {
      this.paramType = 'fixed';
      this.paramValue = '';
      this.fieldSelected = '';
      this.onChange();
    },
    options_type(isCsv) {
      if (isCsv) return this.csvHeaders.map(e => ({ key: e, value: e }));

      // Following options contain contact infos
      // If contact doesn't have the selected parameter, campaign will send empty string instead
      return this.availableContactInfos;
    },
  },
};
</script>

<template>
  <div class="flex w-full">
    <select v-model="paramType" class="mb-0 w-1/2">
      <option value="fixed">
        {{ $t('CAMPAIGN.TEMPLATE_PARSER.PARAM_TYPES.FIXED') }}
      </option>
      <option v-if="isOngoing" value="origin">
        {{ $t('CAMPAIGN.TEMPLATE_PARSER.PARAM_TYPES.ORIGIN') }}
      </option>
      <option
        value="dynamic"
        :disabled="csvHeaders.length === 0 && isCsvAudience"
      >
        {{ $t('CAMPAIGN.TEMPLATE_PARSER.PARAM_TYPES.DYNAMIC') }}
      </option>
    </select>
    <woot-input
      v-if="paramType === 'fixed' || paramType === 'origin'"
      v-model="paramValue"
      type="text"
      class="variable-input w-full mb-0"
      @input="onChange($event)"
    />
    <select v-else v-model="fieldSelected" class="mb-0" @change="onChange">
      <option
        v-for="item in options_type(isCsvAudience)"
        :key="item.key"
        :value="item.value"
        :disabled="item.value === 'disabled'"
      >
        {{ item.key }}
      </option>
    </select>
  </div>
</template>
